import { getIntlLocale } from "@/i18n";

const MS_PER_DAY = 86_400_000;

/** Local calendar day key (`YYYY-MM-DD`) for grouping chat messages. */
export function chatLocalDayKey(iso: string): string {
  const date = new Date(iso);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function capitalizeFirst(value: string, locale: string): string {
  if (!value) return value;
  return value.charAt(0).toLocaleUpperCase(locale) + value.slice(1);
}

/**
 * WhatsApp-style day chip label:
 * today → Today; yesterday → Yesterday; last 6 days → weekday;
 * same year → 12 September; older → 12 September 2025.
 */
export function formatChatDaySeparator(
  iso: string,
  labels: { today: string; yesterday: string },
  now: Date = new Date(),
): string {
  const date = new Date(iso);
  const locale = getIntlLocale();
  const msgDay = startOfLocalDay(date);
  const today = startOfLocalDay(now);
  const diffDays = Math.round(
    (today.getTime() - msgDay.getTime()) / MS_PER_DAY,
  );

  if (diffDays === 0) return labels.today;
  if (diffDays === 1) return labels.yesterday;

  if (diffDays > 1 && diffDays < 7) {
    return capitalizeFirst(
      date.toLocaleDateString(locale, { weekday: "long" }),
      locale,
    );
  }

  const sameYear = date.getFullYear() === now.getFullYear();
  return capitalizeFirst(
    date.toLocaleDateString(locale, {
      day: "numeric",
      month: "long",
      ...(sameYear ? {} : { year: "numeric" }),
    }),
    locale,
  );
}
